import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter, ModalProps } from '@slal/ui/modal';
import { Article, Heading, Ol, P, Ul } from '@slal/ui/typography';
import { useCallback } from 'react';
import { StyledLi } from './styles';

const DeclarationModalContent = () => {
    const declarationId = 'your-declaration-title';
    const ourDeclarationId = 'our-declaration-title';
    const transferDeclarations = 'pension-transfer-declaration-title';
    const providerDeclarationId = 'provider-declaration-title';
    const dataProtectionId = 'data-protection-id';
    const fraudPreventionId = 'fraud-prevention-id';

    return (
        <Article>
            <Heading id={declarationId} level={3}>
                Your declaration
            </Heading>
            <Ul aria-labelledby={declarationId}>
                <StyledLi>
                    I confirm the information I've provided in this application is accurate and complete. I understand
                    that this application will be used to apply for tax relief at source and it's a serious offence to
                    give false statements - the penalties are severe and could lead to prosecution.
                </StyledLi>
                <StyledLi>
                    I confirm that I will tell Phoenix Life Limited, trading as Standard Life if any information I have
                    provided in my application changes before my plan starts. I understand that if I don't, or fail to
                    give any other relevant information, it may make my plan void.
                </StyledLi>
                <StyledLi>
                    I am aware that free guidance is available to me from the government's [Pension
                    Wise](https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise) service, a service
                    from MoneyHelper.
                </StyledLi>
                <StyledLi>
                    I understand that the Active Money Personal Pension (AMPP) product is provided under the Standard
                    Life Self Invested Personal Pension Scheme. If my application for an AMPP is accepted, I agree to
                    comply with the rules of the Scheme.
                </StyledLi>
                <StyledLi>
                    I also agree to comply with the Active Money Personal Pension [Terms and
                    Conditions](https://lib.standardlife.com/library/uk/ampp62.pdf).
                </StyledLi>
                <StyledLi>
                    I am aware that I may lose benefits or guarantees under my current plan as a result of a transfer,
                    and that transferring while in poor health could impact inheritance tax should I die within two
                    years.
                </StyledLi>
                <StyledLi>
                    If I'm closing a company pension plan my employer is contributing into, I understand that I may miss
                    out on, or be ineligible for, future employer contributions. I've informed my employer that I'm
                    closing my company pension plan and, if required, l've discussed the implications of this choice
                    with them. I understand that Phoenix Life Limited, trading as Standard Life shall not be responsible
                    for any loss of contributions that occurs.
                </StyledLi>
                <StyledLi>
                    Any tax-free cash I take from this policy may become a deemed unauthorised payment and therefore
                    subject to a tax charge if I choose to pay it into another registered pension scheme. If I choose to
                    recycle the tax-free cash in this way, I will tell ReAssure within 30 days of the date of the
                    unauthorised payment.
                </StyledLi>
                <StyledLi>
                    If I'm applying to make regular or single payments, I declare that the total payments to any
                    registered pension scheme to which I'm entitled to tax relief under section 188 of the Finance Act
                    2004 won't exceed the higher of the 'basic amount - currently £3,600 - or my relevant UK earnings,
                    as defined in section 189 of the Act, for that tax year. Once I've taken all of my tax free cash, if
                    I take any further money from this pension the basic amount will be capped at £10,000.
                </StyledLi>
                <StyledLi>
                    I confirm I will tell Phoenix Life Limited, trading as Standard Life of any changes to my
                    circumstances that mean I'm no longer entitled to receive tax relief on my pension payments. I will
                    do this before the end of the tax year, or within 30 days if this is later.
                </StyledLi>
                <StyledLi>
                    Phoenix Life Limited, trading as Standard Life hasn't provided me with advice or assessed the
                    suitability of my choices.
                </StyledLi>
                <StyledLi>
                    I'm aware of the options available to me under my current plan and under the plan for which I am
                    applying and the tax implications of the choices I've made and I'm happy to proceed with this
                    application.
                </StyledLi>
                <StyledLi>
                    I understand Phoenix Life Limited, trading as Standard Life will send me a copy of all information
                    and declarations I've provided as part of this application. | understand it's my responsibility to
                    check that all the information sent to me is correct. I'II contact Standard Life immediately if
                    there are any errors or omissions.
                </StyledLi>
                <StyledLi>
                    Payment of this tax free lump sum does not cause me to exceed the individual Lump Sum Allowance. For
                    most people this is £268,275.
                </StyledLi>
                <StyledLi>
                    I accept responsibility for any claims, losses or expenses Phoenix Life Limited may incur as a
                    result of any incorrect information provided by me in this application or of any failure on my part
                    to comply with any aspect of this application.
                </StyledLi>
            </Ul>

            <Heading id={ourDeclarationId} level={3}>
                Our declaration
            </Heading>
            <Ul aria-labelledby={ourDeclarationId}>
                <StyledLi>
                    If Phoenix Life Limited accept this application, it agrees, as administrator and provider of the
                    Standard Life Self Invested Personal Pension Scheme, to administer the scheme as required by the
                    rules.
                </StyledLi>
            </Ul>

            <Heading id={transferDeclarations} level={3}>
                Pension transfer declarations
            </Heading>
            <Heading level={4}>Declarations to Phoenix Life Limited</Heading>
            <Ul aria-labelledby={transferDeclarations}>
                <StyledLi>
                    I'm aware the decision to transfer in is mine and I haven't been provided with financial advice.
                </StyledLi>
                <StyledLi>
                    I'm aware that, my transfer will be invested in line with my investment instruction specified in
                    this application. Charges and investment options are likely to be different from the pension I'm
                    transferring.
                </StyledLi>
                <StyledLi>
                    I authorise you exchange all necessary information with the transferring provider as is required to
                    enable the transfer of my pension and pay any benefits under my pension.
                </StyledLi>
                <StyledLi>
                    I'm aware I have 30 days to cancel my transfer, but that if the transferring scheme will not accept
                    the payment back, I will have to arrange for another provider to accept it.
                </StyledLi>
                <StyledLi>
                    I'm aware most pension transfers are made as cash and until invested won't incur investment losses
                    or make investment gains.
                </StyledLi>
                <StyledLi>
                    I confirm the pension l'm transferring is not part of a divorce settlement and has never been
                    subject to a court order.
                </StyledLi>
                <StyledLi>
                    I'm aware there are arrangement and service costs of £150 for arranging this transfer (shown in the
                    Key Features Illustration). I'm aware this is not an additional cost to me, but that it is paid by
                    Phoenix Life Limited out of existing charges on the pension.
                </StyledLi>
            </Ul>

            <Heading id={providerDeclarationId} level={4}>
                Declarations to the transferring provider
            </Heading>

            <P>
                I authorise and instruct you to transfer funds from the pension shown above directly to Standard Life.
            </P>
            <Ol aria-labelledby={providerDeclarationId}>
                <StyledLi>
                    I am aware that, if I do not provide you with any original policy documents you may require, I am
                    responsible for any claims, losses or expenses you may incur as a result.
                </StyledLi>
                <StyledLi>To enable the transfer of funds, I authorise you to:</StyledLi>
                <Ul>
                    <StyledLi>
                        Exchange all necessary information with Phoenix Life Limited to enable my transfer and pay any
                        benefits under my pension{' '}
                    </StyledLi>
                    <StyledLi>Exchange any necessary information with my financial adviser (if I have one).</StyledLi>
                    <StyledLi>
                        Release any relevant information to my employer (this only applies if an employer is paying
                        contributions to the pension).
                    </StyledLi>
                </Ul>
                <StyledLi>
                    Until this transfer request is accepted and complete, I am aware that Phoenix Life Limited's
                    responsibility is limited to the return of the transfer payment.
                </StyledLi>
                <StyledLi>
                    If the transfer payment represents the total value of the pension shown above, then once this
                    transfer request is accepted and complete I am aware that I will no longer be entitled to any
                    benefits from that pension.
                </StyledLi>
                <StyledLi>
                    If the transfer payment represents only part of the value of the pension shown above, then once this
                    transfer request is accepted and complete I am aware that I will no longer be entitled to any
                    benefits from that pension.
                </StyledLi>
            </Ol>
            <P>
                Where I've elected to take the maximum tax-free cash available, I instruct you to pay this to me and to
                transfer the remaining balance as a drawdown arrangement to Phoenix Life Limited.
            </P>
            <P>
                I accept responsibility for any claims, losses or expenses you may incur as a result of any incorrect
                information provided by me in this application or of any failure on my part to comply with any aspect of
                this application.
            </P>

            <Heading id={dataProtectionId} level={3}>
                Data Protection
            </Heading>
            <Ul aria-labelledby={dataProtectionId}>
                <StyledLi>
                    Please read our [Privacy Policy](https://www.standardlife.co.uk/privacy) which applies to the use of
                    your personal and other information by Standard Life and the Phoenix Group companies.
                </StyledLi>
            </Ul>

            <Heading id={fraudPreventionId} level={3}>
                Anti-Money Laundering & Fraud Prevention
            </Heading>
            <Ul aria-labelledby={fraudPreventionId}>
                <StyledLi>
                    To comply with UK Anti-Money Laundering Regulations (AML) we are required to verify our customers
                    identity. This also protects against fraudulent activity.
                </StyledLi>
                <StyledLi>
                    Where possible, we will perform an electronic identity check through a credit reporting agency. The
                    agency will verify your identity against public and other identity records such as your credit
                    footprint. This is not a credit check and will not disclose any information about your actual
                    borrowings. The agency will add a note to your credit record for your awareness only (known as "soft
                    footprint), to make you aware that an identity check was made but the information will not be seen
                    by any third parties.
                </StyledLi>
                <StyledLi>
                    If the electronic check is not successful we will request identification documents and will inform
                    you if this is required.
                </StyledLi>
                <StyledLi>
                    Acceptance of this application is subject to satisfactory completion of identification checks within
                    30 days of the application date.
                </StyledLi>
            </Ul>
        </Article>
    );
};
export const DeclarationModal = ({ isOpen, onClose }: ModalProps) => {
    const closeModal = useCallback(() => {
        onClose();
    }, [onClose]);

    return (
        <Modal isOpen={isOpen} onClose={closeModal} title={'Active Money Personal Pension Declarations'}>
            <ModalBody>
                <DeclarationModalContent />
            </ModalBody>
            <ModalFooter>
                <Button variant="solid" color="secondary" onClick={closeModal}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};
